import { FC } from "react";
import StyledFolder from "./Folder.style";

const Folder: FC = () => {
    
    return (
        <StyledFolder>
            <h3>Folders are not implemented in beta version</h3>
        </StyledFolder>
        )
}

export default Folder;